module.exports = __webpack_public_path__ + "img/listen-on-google-podcasts.6ce55e5d.svg";